import React from "react";
import { Formik } from "formik";
import { isFunction } from "lodash";
import { NotificationManager } from "react-notifications";
import * as Yup from "yup";
import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";

import FormTextInput from "../../../../base/form-text-input";
import FormDropdown from "../../../../base/form-dropdown";
import DatePicker, {
  FORM_DROPDOWN_LABEL_POSITION,
} from "../../../../base/date-picker";
import AppModal from "../../../modals/app-modal";
import DocumentDetailsFormView from "./document-details-form-view";
import SubmittedDocumentsView from "./submitted-documents-view";
import { ID_VERIFICATION_TYPES } from "../../../../../config/constant";
import IdVerificationRejectionModal from "./id-verification-rejection-modal";
import { IdVerificationDomain } from "./domain";
import FormMeta from "./form-meta/index.json";
import idVerificationSchema from "./schema";

import "./style.css";
import UserDetailsView from "./user-details-view";

const IdVerificationModal = ({
  showModal,
  userProfile = {},
  idRequest,
  getUpdatedUserDetails,
  setShowIdVerificationModal = () => {},
}) => {
  const [
    showIdVerificationRejectionModal,
    setShowIdVerificationRejectionModal,
  ] = React.useState(false);

  const refreshUserDetails = async () => {
    if (isFunction(getUpdatedUserDetails)) {
      await getUpdatedUserDetails();
    }
  };

  const onClickAcceptVerification = (values) => {
    try {
      IdVerificationDomain.handleAcceptIdVerification({
        values,
        requestId: idRequest?.id,
        refreshUserDetails,
        setShowIdVerificationModal,
      });
    } catch (error) {
      NotificationManager.error("Unknown error occurred");
      console.log(error);
    }
  };

  return (
    <AppModal
      visibility={showModal}
      showActionButtons={false}
      modalClasses="id-verify-modal"
      title="ID Verification"
      handleClose={() => setShowIdVerificationModal(false)}
    >
      <Formik
        initialValues={IdVerificationDomain.generateInitialFormValues()}
        validationSchema={idVerificationSchema}
        onSubmit={onClickAcceptVerification}
      >
        {({ handleSubmit, isSubmitting }) => (
          <Grid
            item
            container
            direction="column"
            className="id-verify-modal-content"
          >
            <Typography variant="body2" className="subtitle">
              Review the submitted documents and enter the details below.
            </Typography>
            <Grid item container direction="row" className="gap-x-32">
              <SubmittedDocumentsView
                userProfile={userProfile}
                idRequest={idRequest}
              />
              <Divider orientation="vertical" flexItem />
              <Grid
                xs
                item
                container
                direction="column"
                className="gap-y-16"
              >
                <UserDetailsView userProfile={userProfile} />
                <DocumentDetailsFormView />
              </Grid>
            </Grid>
            <Divider />
            <Grid container justifyContent="flex-end" className="gap-x-16">
              <Button
                variant="contained"
                className="reject-button"
                onClick={() => setShowIdVerificationRejectionModal(true)}
              >
                Reject
              </Button>
              <Button
                variant="contained"
                className="accept-button"
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                {isSubmitting ? (
                  <CircularProgress size={25} className="color-white" />
                ) : (
                  "Accept"
                )}
              </Button>
            </Grid>
          </Grid>
        )}
      </Formik>
      <IdVerificationRejectionModal
        showModal={showIdVerificationRejectionModal}
        requestId={idRequest?.id}
        setShowIdVerificationRejectionModal={
          setShowIdVerificationRejectionModal
        }
        setShowIdVerificationModal={setShowIdVerificationModal}
        refreshUserDetails={refreshUserDetails}
      />
    </AppModal>
  );
};

export default IdVerificationModal;
